import React from "react";
import Navbar from "../components/UI/Navbar/Navbar";
import { Outlet } from "react-router-dom";

const MyApplicationsLayout = () => {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
};

export default MyApplicationsLayout;
